import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { EnumPartialRoutes } from './shared/enums/enums';

const routes: Routes = [
  {
    path: '',
    pathMatch: 'full',
    redirectTo: `${EnumPartialRoutes.MEDICAL_RECORD}`
  },
  {
    path: EnumPartialRoutes.MEDICAL_RECORD,
    loadChildren: () => import('./features/medical-record/medical-record.module').then(m => m.MedicalRecordModule),
  },
  {
    path: EnumPartialRoutes.AUTHENTICATION,
    loadChildren: () => import('./features/authentication/authentication.module').then(m => m.AuthenticationModule),
  },
  {
    path: EnumPartialRoutes.SCHEDULE,
    loadChildren: () => import('./features/schedule/schedule.module').then(m => m.ScheduleModule),
  },
  {
    path: EnumPartialRoutes.TREATMENT_HISTORY,
    loadChildren: () => import('./features/treatment-history/treatment.module').then(m => m.TreatmentModule),
  },
  {
    path: EnumPartialRoutes.EXTERNAL,
    loadChildren: () => import('./features/external/external.module').then(m => m.ExternalModule),
  },
  {
    path: '.well-known/apple-app-site-association',
    pathMatch: 'full',
    redirectTo: `/.well-known/apple-app-site-association`
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
